import React from 'react';

// Fig Health brand icon - stylized fig fruit
export const FigIcon = ({ className = "w-8 h-8" }) => {
  return (
    <svg 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Fig fruit body */}
      <path 
        d="M16 28C10 28 6 23 6 17C6 11 10 7 16 7C22 7 26 11 26 17C26 23 22 28 16 28Z" 
        stroke="currentColor" 
        strokeWidth="2" 
        fill="none"
      />
      {/* Stem */}
      <path 
        d="M16 7V3" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      {/* Leaf */}
      <path 
        d="M16 5C18 4 20 4 21 6" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round"
        fill="none"
      />
      {/* Inner detail line */}
      <path 
        d="M16 12V22" 
        stroke="currentColor" 
        strokeWidth="1" 
        strokeLinecap="round"
        opacity="0.4"
      />
    </svg>
  );
};

export default FigIcon;
